document.addEventListener("DOMContentLoaded", function () {

  /****************************************************
   *  PART A: Existing purchase-option display logic  *
   *  (Adapted for Appstle)                           *
   ****************************************************/
  function isPWA() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
  }

  function handlePurchaseOptionChange() {
    var subscribeRadio = document.getElementById("bb-sub-subscribe");
    var oneTimeRadio = document.getElementById("bb-sub-one-time");
    var subscriptionSelect = document.getElementById("global-subscription-select");
    var bulletsDiv = document.querySelector('.bb-sub-bullets');
    var noteDiv = document.querySelector('.bb-sub-note');

    if (subscribeRadio && subscribeRadio.checked) {
      subscriptionSelect.style.display = "";
      bulletsDiv.style.display = "";
      noteDiv.style.display = "";
    } else if (oneTimeRadio && oneTimeRadio.checked) {
      // Optionally hide subscription fields if needed:
      // subscriptionSelect.style.display = "none";
      // bulletsDiv.style.display = "none";
      // noteDiv.style.display = "none";
    }
    updateActiveClass();
  }

  function updateActiveClass() {
    document.querySelectorAll('.bb-sub-row').forEach(row => {
      const radio = row.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        row.classList.add('sub-select-active');
      } else {
        row.classList.remove('sub-select-active');
      }
    });
  }

  // Add event listeners for purchase option changes
  document.querySelectorAll('input[name="purchase-option"]').forEach(radio => {
    radio.addEventListener("change", handlePurchaseOptionChange);
  });

  // Make parent divs clickable to select radio
  document.querySelectorAll('.bb-sub-row').forEach(div => {
    div.addEventListener('click', function(e) {
      // Avoid toggling if user clicked inside a <select> or child element
      if (
        e.target === this ||
        (e.target.parentNode === this &&
         !e.target.closest('select') &&
         e.target.tagName !== 'SELECT')
      ) {
        const radio = this.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change'));
        }
      }
    });
  });

  // The "Add to Cart" button for Appstle
  const addToCartOriginal = document.getElementById("add-to-cart");
  if (addToCartOriginal) {
    addToCartOriginal.addEventListener("click", function () {
      var itemsToAdd = [];
      document.querySelectorAll(".bundle-builder .product-item").forEach(function (item) {
        var quantity = parseInt(item.querySelector('input[name="quantity"]').value) || 0;
        if (quantity > 0) {
          var variantId = item.getAttribute("data-variant-id");
          var selectedSellingPlan = null;
          var subscribeRadio = document.getElementById("bb-sub-subscribe");
          
          // For Appstle, we use the selling plan ID directly
          if (subscribeRadio && subscribeRadio.checked) {
            var globalSubscriptionSelect = document.getElementById("global-subscription-select");
            selectedSellingPlan = globalSubscriptionSelect ? globalSubscriptionSelect.value : null;
          }
          
          var itemToAdd = {
            id: variantId,
            quantity: quantity
          };
          
          // Add selling plan for Appstle if subscription is selected
          if (selectedSellingPlan) {
            itemToAdd.selling_plan = selectedSellingPlan;
          }
          
          itemsToAdd.push(itemToAdd);
        }
      });

      if (itemsToAdd.length > 0) {
        var bodyContent = { items: itemsToAdd };
        if (isPWA()) {
          bodyContent.attributes = { source: 'PWA' };
        }
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyContent),
        })
        .then((response) => response.json())
        .then((cart) => {
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
        });
      }
    });
  }

  // Initial run to ensure correct display states
  updateActiveClass();
  handlePurchaseOptionChange();

  /****************************************************
   *  PART B: Appstle-specific subscription logic     *
   ****************************************************/
  let selectedProducts = new Map();

  function initializeQuantityListeners() {
    const inputs = document.querySelectorAll('.bb-input');
    inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        updateSelectedProducts(input, parseInt(e.target.value, 10));
      });
      
      const container = input.closest('.quantity-selector');
      if (!container) return;
      
      const increaseBtn = container.querySelector('.increase-quantity');
      const decreaseBtn = container.querySelector('.decrease-quantity');
      
      if (increaseBtn) {
        increaseBtn.addEventListener('click', () => {
          setTimeout(() => {
            updateSelectedProducts(input, parseInt(input.value, 10));
          }, 100);
        });
      }
      
      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', () => {
          setTimeout(() => {
            updateSelectedProducts(input, parseInt(input.value, 10));
          }, 100);
        });
      }
      
      // Store any initial nonzero values
      if (parseInt(input.value, 10) > 0) {
        updateSelectedProducts(input, parseInt(input.value, 10));
      }
    });
  }

  function updateSelectedProducts(productElement, quantity) {
    const productItem = productElement.closest('.product-item');
    if (!productItem) {
      console.error('No product item found');
      return;
    }
    const productId = parseInt(productItem.dataset.variantId, 10);
    if (!productId) {
      console.error('Invalid product ID:', productItem.dataset.variantId);
      return;
    }
    
    if (quantity > 0) {
      // For Appstle, we store the selling plans with their IDs
      const sellingPlans = {
        '2-week': '712482652545',
        '3-week': '712518107521', 
        '4-week': '712482685313',
        '5-week': '712518140289',
        '6-week': '712482718081',
        '7-week': '712518173057',
        '8-week': '712482750849'
      };
      
      selectedProducts.set(productId, {
        quantity: quantity,
        sellingPlans: sellingPlans
      });
    } else {
      selectedProducts.delete(productId);
    }
  }

  // Button for DIRECT TO CHECKOUT (Appstle version)
  async function handleAddToCheckout(e) {
    e.preventDefault();
    const button = e.currentTarget;
    button.disabled = true;
    button.innerText = 'Adding to Cart...';

    try {
      // Get subscription settings
      const subscribeRadio = document.getElementById("bb-sub-subscribe");
      const isSubscription = subscribeRadio && subscribeRadio.checked;
      let sellingPlanId = null;
      
      if (isSubscription) {
        const globalSubscriptionSelect = document.getElementById("global-subscription-select");
        sellingPlanId = globalSubscriptionSelect ? globalSubscriptionSelect.value : null;
      }

      // Build cart items for Appstle
      const cartItems = [];
      selectedProducts.forEach((productData, variantId) => {
        if (productData.quantity > 0) {
          const item = {
            id: variantId,
            quantity: productData.quantity
          };
          
          // Add selling plan for Appstle if subscription is selected
          if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
          }
          
          cartItems.push(item);
        }
      });

      if (cartItems.length === 0) {
        throw new Error('No items selected');
      }

      // Add to cart via Shopify Cart API
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: cartItems })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Successfully added to cart:', result);

      // For Appstle, we can redirect to cart or checkout
      if (isSubscription && sellingPlanId) {
        // For subscription items, we might want to redirect to checkout with selling plan
        const checkoutUrl = `/cart?selling_plan=${sellingPlanId}`;
        window.location.href = checkoutUrl;
      } else {
        // Regular cart redirect
        window.location.href = '/cart';
      }

    } catch (error) {
      console.error('Error during checkout:', error);
      alert('Error adding items to cart. Please try again.');
    } finally {
      button.disabled = false;
      button.innerText = 'Continue';
    }
  }

  // Initialize quantity listeners
  initializeQuantityListeners();

  // Attach checkout handler if button exists
  const checkoutButton = document.getElementById("add-to-checkout");
  if (checkoutButton) {
    checkoutButton.addEventListener("click", handleAddToCheckout);
  }

  // Continue button functionality for bundle builder
  const continueButton = document.getElementById("bb-continue");
  if (continueButton) {
    continueButton.addEventListener("click", function() {
      // Show the subscription widget
      const subscriptionWidget = document.getElementById('subscription-wid-wrap');
      if (subscriptionWidget) {
        subscriptionWidget.style.display = 'block';
        subscriptionWidget.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // Back button functionality
  const backButton = document.getElementById("bb-back");
  if (backButton) {
    backButton.addEventListener("click", function() {
      // Hide the subscription widget
      const subscriptionWidget = document.getElementById('subscription-wid-wrap');
      if (subscriptionWidget) {
        subscriptionWidget.style.display = 'none';
      }
      
      // Scroll back to products
      const productContainer = document.querySelector('.bundle-builder');
      if (productContainer) {
        productContainer.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

});
